/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargo_Diff_LabelInputs */

const en_cargo_diff_label = /** @type {(inputs: Cargo_Diff_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diff ($/lb)`)
};

const es_cargo_diff_label = /** @type {(inputs: Cargo_Diff_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dif ($/lb)`)
};

/**
* | output |
* | --- |
* | "Diff ($/lb)" |
*
* @param {Cargo_Diff_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_diff_label = /** @type {((inputs?: Cargo_Diff_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_Diff_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_diff_label(inputs)
	return es_cargo_diff_label(inputs)
});